const defaultLogger = console;

export { defaultLogger };
//# sourceMappingURL=logger.esm.js.map
